var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.855 -0.855 24 24",
    id: "Filter-2--Streamline-Core.svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Filter 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-2--funnel-filter-angle-oil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.49392857142857 0.7960714285714285H0.7960714285714285l7.960714285714285 11.145v9.552857142857142l4.776428571428571 -3.184285714285714v-6.368571428571428l7.960714285714285 -11.145Z",
    strokeWidth: 1.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOpen);
export default __webpack_public_path__ + "static/media/Filter-open.660b81a7603294e0b1a7259a15b3cfff.svg";
export { ForwardRef as ReactComponent };